module.exports = __webpack_public_path__ + "img/rjcStatement.aba2cf5.jpg";